import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ArrowSyncSvg = function ArrowSyncSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.767 5.725-2.439-2.431 1.048-1.044 4.227 4.213-4.227 4.213-1.048-1.044 2.44-2.43H3.48v5.72H2V5.726zM22 18.275v-7.198h-1.482V16.8H8.234l2.439-2.431-1.048-1.044-4.227 4.213 4.227 4.213 1.048-1.044-2.44-2.431z"
  }));
};
export var ArrowSync = function ArrowSync(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ArrowSyncSvg
  }));
};